import baseView from './base-view';
import utils from './utils';
import views from './views';

const youi = {
  baseView,
  utils,
  views,
};

export default youi;
youi;
